import { render, staticRenderFns } from "./PointCard.vue?vue&type=template&id=34a12dc2&scoped=true&"
import script from "./PointCard.vue?vue&type=script&lang=js&"
export * from "./PointCard.vue?vue&type=script&lang=js&"
import style0 from "./PointCard.vue?vue&type=style&index=0&id=34a12dc2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a12dc2",
  null
  
)

export default component.exports